<div class="container mx-auto py-10">
  <!-- Header -->
  <div class="flex items-center justify-between space-y-2 mb-8">
    <div>
      <h2 class="text-3xl font-bold tracking-tight">Clientes con App</h2>
      <p class="text-muted-foreground">
        Personas que usan la app nueva, con su versión y por dónde entraron la última vez
      </p>
    </div>
    <div class="flex items-center gap-2">
      <button (click)="exportExcel()"
              class="inline-flex items-center gap-2 rounded-md bg-green-600 text-white px-3 py-2 text-sm font-medium hover:bg-green-700 transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
              [disabled]="exporting || loading"
              title="Descargar todos los clientes del filtro actual en Excel">
        <i class="fas" [ngClass]="exporting ? 'fa-spinner fa-spin' : 'fa-file-excel'"></i>
        {{ exporting ? 'Generando…' : 'Descargar Excel' }}
      </button>
      <button (click)="load()"
              class="inline-flex items-center gap-2 rounded-md border border-gray-200 bg-white px-3 py-2 text-sm font-medium hover:bg-gray-50 transition-colors"
              [disabled]="loading">
        <i class="fas fa-sync-alt" [class.fa-spin]="loading"></i>
        Actualizar
      </button>
    </div>
  </div>

  <!-- KPI: total de clientes con la app nueva -->
  <div class="mb-6">
    <div class="rounded-lg border bg-card text-card-foreground shadow-sm w-full sm:max-w-xs">
      <div class="p-6 flex flex-row items-center justify-between space-y-0 pb-2">
        <h3 class="tracking-tight text-sm font-medium">Clientes con la app nueva</h3>
        <i class="fas fa-mobile-alt text-gray-400"></i>
      </div>
      <div class="p-6 pt-0">
        <div class="text-3xl font-bold">{{ stats.total_with_app }}</div>
        <p class="text-xs text-muted-foreground">Todas las personas que usan la app nueva</p>
      </div>
    </div>
  </div>

  <!-- Toolbar -->
  <div class="flex flex-col md:flex-row md:items-center gap-3 mb-4">
    <div class="relative flex-1">
      <i class="fas fa-search absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm"></i>
      <input type="text"
             [ngModel]="search"
             (ngModelChange)="onSearchChange($event)"
             placeholder="Buscar por nombre, cédula o correo…"
             class="w-full rounded-md border border-gray-200 bg-white pl-9 pr-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400" />
    </div>
    <select [ngModel]="channel" (ngModelChange)="onChannelChange($event)"
            class="rounded-md border border-gray-200 bg-white px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400">
      <option value="all">Todos (con la app nueva)</option>
      <option value="new">Solo App V2 (último acceso)</option>
    </select>
    <select [ngModel]="sort" (ngModelChange)="onSortChange($event)"
            class="rounded-md border border-gray-200 bg-white px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400">
      <option value="recent">Más recientes</option>
      <option value="name">Nombre (A-Z)</option>
    </select>
  </div>

  <!-- Table -->
  <div class="rounded-lg border bg-card shadow-sm overflow-hidden">
    <div class="overflow-x-auto">
      <table class="w-full caption-bottom text-sm">
        <thead class="border-b bg-gray-50/50">
          <tr>
            <th class="h-12 px-4 text-left align-middle font-medium text-muted-foreground">Cliente</th>
            <th class="h-12 px-4 text-left align-middle font-medium text-muted-foreground">Cédula</th>
            <th class="h-12 px-4 text-left align-middle font-medium text-muted-foreground">Versión de la app</th>
            <th class="h-12 px-4 text-left align-middle font-medium text-muted-foreground">Fecha</th>
            <th class="h-12 px-4 text-left align-middle font-medium text-muted-foreground">Estado</th>
            <th class="h-12 px-4 text-right align-middle font-medium text-muted-foreground"></th>
          </tr>
        </thead>
        <tbody>
          <!-- Loading -->
          <tr *ngIf="loading">
            <td colspan="6" class="p-8 text-center text-muted-foreground">
              <i class="fas fa-spinner fa-spin mr-2"></i> Cargando clientes…
            </td>
          </tr>

          <!-- Empty -->
          <tr *ngIf="!loading && rows.length === 0">
            <td colspan="6" class="p-10 text-center text-muted-foreground">
              <i class="fas fa-mobile-alt text-3xl text-gray-300 mb-2 block"></i>
              No se encontraron clientes con la app.
            </td>
          </tr>

          <!-- Rows -->
          <tr *ngFor="let row of rows; trackBy: trackById"
              class="border-b transition-colors hover:bg-gray-50/70 cursor-pointer"
              (click)="openDetail(row)">
            <!-- Cliente -->
            <td class="p-4 align-middle">
              <div class="flex items-center gap-3">
                <div class="flex-shrink-0 w-9 h-9 rounded-full bg-indigo-100 text-indigo-700 flex items-center justify-center text-xs font-bold">
                  {{ initials(row) }}
                </div>
                <div class="min-w-0">
                  <div class="font-medium text-gray-900 truncate">{{ fullName(row) }}</div>
                  <div class="text-xs text-muted-foreground truncate" *ngIf="row.email">{{ row.email }}</div>
                </div>
              </div>
            </td>
            <!-- Cédula -->
            <td class="p-4 align-middle text-gray-700">{{ row.username || '—' }}</td>
            <!-- Versión de la app -->
            <td class="p-4 align-middle">
              <span *ngIf="row.app_version"
                    class="inline-flex items-center px-2 py-0.5 rounded text-xs font-bold bg-indigo-600 text-white">
                v{{ row.app_version }}
              </span>
              <span *ngIf="!row.app_version" class="text-gray-400 text-xs"
                    title="El cliente está en la app nueva, pero su build todavía no reporta la versión. Aparecerá cuando actualice y vuelva a entrar.">
                Sin reportar
              </span>
            </td>
            <!-- Fecha (cuándo se detectó la versión) -->
            <td class="p-4 align-middle text-gray-700">
              <span *ngIf="row.app_version_updated_at">{{ row.app_version_updated_at | date:'dd/MM/yyyy HH:mm' }}</span>
              <span *ngIf="!row.app_version_updated_at" class="text-gray-400">—</span>
            </td>
            <!-- Estado -->
            <td class="p-4 align-middle">
              <div class="flex items-center gap-2">
                <span class="inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-semibold"
                      [ngClass]="row.status ? 'bg-green-50 text-green-700 border border-green-200' : 'bg-red-50 text-red-700 border border-red-200'">
                  {{ row.status ? 'Activo' : 'Inactivo' }}
                </span>
                <span *ngIf="row.is_online" class="inline-flex items-center gap-1 text-xs text-green-600" title="Sesión activa">
                  <span class="w-2 h-2 rounded-full bg-green-500"></span> En línea
                </span>
              </div>
            </td>
            <!-- Acción -->
            <td class="p-4 align-middle text-right">
              <button (click)="$event.stopPropagation(); openDetail(row)"
                      class="inline-flex items-center gap-1 rounded-md px-2 py-1 text-xs font-medium text-blue-600 hover:bg-blue-50 transition-colors">
                Ver <i class="fas fa-chevron-right text-[10px]"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div *ngIf="!loading && total > 0" class="flex items-center justify-between px-4 py-3 border-t">
      <span class="text-xs text-muted-foreground">
        Mostrando <strong>{{ rangeFrom }}</strong>–<strong>{{ rangeTo }}</strong> de <strong>{{ total }}</strong>
      </span>
      <div class="flex items-center gap-2">
        <button (click)="prevPage()" [disabled]="page <= 1"
                class="rounded-md border border-gray-200 px-2.5 py-1 text-sm hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed">
          <i class="fas fa-chevron-left text-xs"></i>
        </button>
        <span class="text-xs text-muted-foreground">Página {{ page }} de {{ totalPages }}</span>
        <button (click)="nextPage()" [disabled]="page >= totalPages"
                class="rounded-md border border-gray-200 px-2.5 py-1 text-sm hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed">
          <i class="fas fa-chevron-right text-xs"></i>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- ═══════════════════════════════════════════════════════════════════════ -->
<!-- Drawer de detalle (lado derecho)                                        -->
<!-- ═══════════════════════════════════════════════════════════════════════ -->
<ng-template #detailDrawer let-offcanvas>
  <div class="offcanvas-header border-b flex items-center justify-between px-5 py-4">
    <div class="flex items-center gap-3">
      <div class="w-10 h-10 rounded-full bg-indigo-100 text-indigo-700 flex items-center justify-center text-sm font-bold">
        {{ selected ? initials(selected) : '' }}
      </div>
      <div>
        <h5 class="text-base font-bold text-gray-900 m-0">{{ selected ? fullName(selected) : '' }}</h5>
        <span class="text-xs text-muted-foreground">Cédula {{ selected?.username || '—' }}</span>
      </div>
    </div>
    <button type="button" class="text-gray-400 hover:text-gray-600" (click)="offcanvas.dismiss()">
      <i class="fas fa-times text-lg"></i>
    </button>
  </div>

  <div class="offcanvas-body px-5 py-4 space-y-5" *ngIf="selected">
    <!-- App -->
    <div>
      <h6 class="text-xs font-semibold text-muted-foreground uppercase tracking-wide mb-2">Aplicación</h6>
      <div class="rounded-lg border bg-white p-4 space-y-3">
        <div class="flex items-center justify-between">
          <span class="text-sm text-gray-600">Versión de la app</span>
          <span *ngIf="selected.app_version" class="inline-flex items-center px-2 py-0.5 rounded text-xs font-bold bg-indigo-600 text-white">v{{ selected.app_version }}</span>
          <span *ngIf="!selected.app_version" class="text-sm text-gray-400" title="Está en la app nueva, pero su build todavía no reporta la versión.">Sin reportar</span>
        </div>
        <div class="flex items-center justify-between">
          <span class="text-sm text-gray-600">Últ. inicio de sesión</span>
          <span *ngIf="selected.uses_new_app" class="inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-semibold bg-green-50 text-green-700 border border-green-200">
            <i class="fas fa-check-circle text-green-600 text-[10px]"></i> App V2
          </span>
          <span *ngIf="!selected.uses_new_app" class="inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-semibold bg-amber-50 text-amber-700 border border-amber-200">
            <i class="fas fa-history text-amber-600 text-[10px]"></i> App V1
          </span>
        </div>
        <div class="flex items-center justify-between">
          <span class="text-sm text-gray-600">Versión detectada el</span>
          <span class="text-sm text-gray-800">{{ selected.app_version_updated_at ? (selected.app_version_updated_at | date:'dd/MM/yyyy HH:mm') : '—' }}</span>
        </div>
      </div>
    </div>

    <!-- Cliente -->
    <div>
      <h6 class="text-xs font-semibold text-muted-foreground uppercase tracking-wide mb-2">Cliente</h6>
      <div class="rounded-lg border bg-white p-4 space-y-3">
        <div class="flex items-center justify-between">
          <span class="text-sm text-gray-600">Nombre</span>
          <span class="text-sm text-gray-800">{{ fullName(selected) }}</span>
        </div>
        <div class="flex items-center justify-between">
          <span class="text-sm text-gray-600">Cédula</span>
          <span class="text-sm text-gray-800">{{ selected.username || '—' }}</span>
        </div>
        <div class="flex items-center justify-between">
          <span class="text-sm text-gray-600">Correo</span>
          <span class="text-sm text-gray-800 truncate max-w-[60%] text-right">{{ selected.email || '—' }}</span>
        </div>
        <div class="flex items-center justify-between">
          <span class="text-sm text-gray-600">Estado</span>
          <span class="inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-semibold"
                [ngClass]="selected.status ? 'bg-green-50 text-green-700 border border-green-200' : 'bg-red-50 text-red-700 border border-red-200'">
            {{ selected.status ? 'Activo' : 'Inactivo' }}
          </span>
        </div>
        <div class="flex items-center justify-between">
          <span class="text-sm text-gray-600">Sesión</span>
          <span class="text-sm" [ngClass]="selected.is_online ? 'text-green-600' : 'text-gray-500'">
            {{ selected.is_online ? 'En línea' : 'Sin sesión activa' }}
          </span>
        </div>
      </div>
    </div>

    <!-- Acción: ir al perfil -->
    <a *ngIf="selected.person_code"
       [routerLink]="['/console/person/profile', selected.person_code]"
       (click)="offcanvas.dismiss()"
       class="flex items-center justify-center gap-2 w-full rounded-md bg-blue-600 text-white px-4 py-2.5 text-sm font-semibold hover:bg-blue-700 transition-colors">
      <i class="fas fa-user"></i> Ver perfil del cliente
    </a>
  </div>
</ng-template>
